module.exports = __webpack_public_path__ + "img/the_execuition.e664214f.png";